// src/components/AdvantageSection.jsx
"use client";

import { useRef } from "react";
import Image from "next/image";

// Array of advantage cards data
const advantageCards = [
  {
    title: "Industry-Relevant Skills",
    description: "Stay ahead in your field by mastering high-demand skills through our online sessions",
    image: "https://d3kl8zsmmx4oop.cloudfront.net/Card_5_0fe9b6d5df.png"
  },
  
  {
    title: "Career Opportunities",
    description: "Tap into a wealth of career opportunities through our established network.",
    image: "https://d3kl8zsmmx4oop.cloudfront.net/Card_7_444b043af8.png"
  },
  {
    title: "Community at the Center",
    description: "Engage with your vibrant community of learners and seasoned industry mentors",
    image: "https://d3kl8zsmmx4oop.cloudfront.net/Card_8_f9fc775756.png"
  },
  {
    title: "Learn by Doing",
    description: "Dive into real challenges from today's businesses, gaining hands-on experience.",
    image: "https://d3kl8zsmmx4oop.cloudfront.net/Card_6_05c70428d9.png"
  },
];

export default function AdvantageSection() {
  const scrollRef = useRef(null);

  return (
    <section className="pt-8 md:py-16">
      <div className="w-[90%] md:w-[80%] mx-auto">
        <div className="mb-10">
        <h2 className="text-[#002726] text-[18px] md:text-base font-medium uppercase mb-1">Designed for your career Growth</h2>
        <h3 className="text-[#002726] text-[24px] md:text-4xl font-medium">Get the GrowthSchool Advantage</h3>
        </div>
      </div>

      {/* Scrollable cards container */}
      <div className="relative overflow-x-auto hide-scrollbar" ref={scrollRef}>
        <div className="flex gap-6 pl-[10%] pr-8 pb-6">
          {advantageCards.map((card, index) => (
            <div 
              key={index} 
              className="flex-shrink-0 w-[300px] h-[500px] md:w-[405px] md:h-[600px] rounded-[16px] overflow-hidden relative border border-gray-200"
            >
              {/* Background image */}
              <div className="absolute inset-0 w-full h-full">
                <Image
                  src={card.image}
                  alt={card.title}
                  fill
                  className="object-cover"
                />
              </div>
              
              {/* Gradient overlay */}
              <div 
                className="absolute inset-0 w-full h-full" 
                style={{
                  backgroundImage: "linear-gradient(rgb(0, 39, 38) 0%, rgba(255, 255, 255, 0) 50%, rgb(0, 39, 38) 100%)"
                }}
              />
              
              {/* Content */}
              <div className="relative z-10 h-full p-6">
                <div>
                  <h3 className="text-white text-base font-medium mb-3">{card.title}</h3>
                  <p className="text-white text-sm font-normal opacity-90">{card.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Add custom CSS for hiding scrollbar but enabling scroll */}
      <style jsx global>{`
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>
  );
}